export enum FetchType {
    MLC = 'mlc',
    TRANSACTION = 'transaction',
    HFA = 'hfa',
}
